import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import {
  Getpermission,
  Activepermission,
  Inactivepermission,
} from "../../../store/permission-store/permission-actions";
import Loading from "../../../components/UI/Loading";
import { getTokenInfo } from "../../../utils/Guard";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const PermissionDetail = () => {
  const param = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const permission = useSelector((state) => state.permission.permission);
  const notification = useSelector((state) => state.ui.notification);
  const userInfo = getTokenInfo();

  useEffect(() => {
    if (permission.id !== undefined || permission.id !== 0) {
      dispatch(Getpermission(param.permissionId, userInfo.Email));
    }
  }, [param.permissionId, dispatch, permission.id, userInfo.Email]);

  const activeHandler = () => {
    dispatch(Activepermission(param.permissionId, userInfo.Email));
  };
  const inactiveHandler = () => {
    dispatch(Inactivepermission(param.permissionId, userInfo.Email));
  };

  const permissionData = [
    { label: "Nombre", value: permission.name },
    { label: "Código", value: permission.code },
    { label: "Descripción", value: permission.description },
  ];

  let activeSuspend;
  // if (
  //   userInfo.Roles !== undefined &&
  //   userInfo.Roles.includes("permission.active")
  // ) {
  //   activeSuspend = (
  //     <div className="field col-12 md:col-3">
  //       <Button
  //         rounded
  //         text
  //         raised
  //         style={{ backgroundColor: "#fff", width: "150px" }}
  //         label="Activar"
  //         className="p-button-success"
  //         onClick={activeHandler}
  //         icon={
  //           notification && notification.status === "pending"
  //             ? "pi pi-spin pi-spinner"
  //             : "pi pi-check"
  //         }
  //         disabled={notification && notification.status === "pending"}
  //       />
  //     </div>
  //   );
  // }
  // if (permission.status) {
  //   if (
  //     userInfo.Roles !== undefined &&
  //     userInfo.Roles.includes("permission.inactive")
  //   ) {
  //     activeSuspend = (
  //       <div className="field col-12 md:col-3">
  //         <Button
  //           rounded
  //           text
  //           raised
  //           style={{ backgroundColor: "#fff", width: "150px" }}
  //           label="Suspender"
  //           className="p-button-warning"
  //           onClick={inactiveHandler}
  //           icon={
  //             notification && notification.status === "pending"
  //               ? "pi pi-spin pi-spinner"
  //               : "pi pi-times"
  //           }
  //           disabled={notification && notification.status === "pending"}
  //         />
  //       </div>
  //     );
  //   }
  // }

  return (
    <>
      <div
        style={{ backgroundColor: "#133047", padding: "1%", height: "100vh" }}
      >
        {(permission.id === undefined || permission.id <= 0) && (
          <>
            <Loading />
          </>
        )}
        {(permission.id !== undefined || permission.id > 0) && (
          <Card
            style={{
              backgroundColor: "#F9FAFB",
              marginLeft: "0%",
              boxShadow: "none",
              width: "100%",
              height: "auto",
            }}
          >
            <div
              className="user-info text-center"
              style={{ borderBottom: "solid #fff", paddingBottom: "1.3%" }}
            >
              <h2 id="header" className="mb-2" style={{ color: "" }}>
                {permission.name}
              </h2>
              <span
                className="badge bg-label-secondary"
                style={{
                  fontSize: "large",
                  color: "#D34330",
                  fontWeight: "bold",
                }}
              >
                Permiso
              </span>
            </div>
            <div className="formgrid grid mt-3">
              <div className="field col-12 md:col-12 mt-3">
                <DataTable
                  value={permissionData}
                  style={{ width: "100%", padding: "1%" }}
                >
                  <Column
                    field="label"
                    style={{
                      width: "50%",
                      textAlign: "right",
                      fontWeight: "bold",
                    }}
                    bodyStyle={{ textAlign: "left" }}
                  />
                  <Column
                    field="value"
                    style={{ width: "50%", textAlign: "left" }}
                    bodyStyle={{ textAlign: "left" }}
                  />
                </DataTable>
              </div>
              <div className="field col-12 md:col-3">
                <Button
                  rounded
                  text
                  raised
                  style={{ backgroundColor: "#fff", width: "150px" }}
                  label="Regresar"
                  icon="pi pi-arrow-left"
                  className="p-button-danger"
                  onClick={() => {
                    navigate("/permissions");
                  }}
                />
              </div>

              {/* {userInfo.Roles !== undefined &&
                userInfo.Roles.includes("permission.edit") && (
                  <div className="field col-12 md:col-3">
                    <Button
                      rounded
                      text
                      raised
                      style={{
                        backgroundColor: "#fff",
                        width: "150px",
                        marginTop: "1%",
                      }}
                      label="Editar"
                      icon="pi pi-file-edit"
                      className="p-button-primary"
                      onClick={() => {
                        navigate(`/permissions/edit/${permission.id}`);
                      }}
                    />
                  </div>
                )} */}
              {activeSuspend}
            </div>
          </Card>
        )}
      </div>
    </>
  );
};
export default PermissionDetail;
